import '../Styles/ProfileCard.css';

export function ProfileCard({ items = [], image, activeId, alignment = 'left' }) {
	return (
		<div className="profile-content-wrapper fade-in" key={activeId} style={{ textAlign: alignment }}>
			{image && (
				<div className="profile-image-container">
					<img src={image} alt="Section icon" className="profile-section-img" />
				</div>
			)}

			<div className="profile-text-wrapper">
				{items.map((item, index) => {
					if (item.type === 'header') {
						return (
							<p key={index} className="item-header">
								<b>{item.content}</b>
							</p>
						);
					}
					else if (item.type === 'title') {
						return (
							<p key={index} className="item-title">
								<b>{item.content}</b>
							</p>
						);
					}
					return (
						<p key={index} className={`item-text ${item.highlight ? 'highlight' : ''}`}>
							{item.content}
						</p>
					);
				})}
			</div>
		</div>
	);
}